import { render, staticRenderFns } from "./SettingsAlertCard.vue?vue&type=template&id=d959b33e&"
import script from "./SettingsAlertCard.vue?vue&type=script&lang=ts&"
export * from "./SettingsAlertCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports